import client from './client';
export const billingAPI = {
    async getStatus() {
        const response = await client.get('/billing/status');
        return response.data.data;
    },
    async createCheckoutSession(plan) {
        const response = await client.post('/billing/checkout', { plan });
        return response.data.data;
    },
    async createPortalSession() {
        const response = await client.post('/billing/portal');
        return response.data.data;
    },
};
